<div class="guided-tour-skeleton">
  <e-spinner [show]="true"></e-spinner>
</div>
